import React, { useState, useEffect } from 'react';
import { Form, Row, Col, Container, Button, Alert } from 'react-bootstrap';
import FormControl from 'react-bootstrap/FormControl';
// import InputMask from 'react-input-mask';

import { useDispatch, useSelector } from 'react-redux';

import { history } from '../../../_helpers';
import { 
  webInquiryActions,
  alertActions
} from '../../../_actions';

import './WebInquiryForm.css';

const WebInquiryForm = () => {
  const [inputs, setInputs] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    message: ''
  });

  const [validated, setValidated] = useState(false);
  const { 
    firstName,
    lastName,
    email,
    phoneNumber,
    message
  } = inputs;
  const alert = useSelector(state => state.alert);
  const dispatch = useDispatch();

  
  useEffect(() => {
    history.listen((location, action) => {
        // clear alert on location change
        dispatch(alertActions.clear());
    });
  }, [dispatch]);

  function handleChange(e) {
    const { name, value } = e.target;
    setInputs(inputs => ({ ...inputs, [name]: value }));
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
      dispatch(webInquiryActions.sendWebInquiry(inputs));
    }

    setValidated(true);
  };

  return (
    <div id="contact-form" className="section landing-section">
      <Container>
        <Row>
          <Col className="ml-auto mr-auto" md="8">
            {alert.message &&
              <Alert variant={`alert ${alert.type}`}>{alert.message}</Alert>
            }
            <h2 className="text-center">Contact Form</h2>
            <Row>
              <span className="login-form-hint">All fields marked with an <span className="required-mark">*</span> (asterisk) are required.</span>
            </Row>
            <Form 
              className="contact-form"
              noValidate validated={validated}
              onSubmit={handleSubmit}
            >
              <Row>
                <Col md="6">
                  <Form.Group
                    controlId="firstName"
                  >
                    <Form.Label className="contact-form-label">First Name <span className="required-mark">*</span></Form.Label>
                    <Form.Control 
                      name="firstName"
                      type="text"
                      value={firstName || ''}
                      onChange={handleChange}
                      required
                      placeholder="Type your First Name here..." />
                    <FormControl.Feedback type="invalid">
                      Please provide a valid first name.
                    </FormControl.Feedback>
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label className="contact-form-label">Last Name <span className="required-mark">*</span></Form.Label>
                    <Form.Control 
                      name="lastName"
                      type="text"
                      value={lastName || ''}
                      onChange={handleChange}
                      required
                      placeholder="Type your Last Name here..." />
                    <FormControl.Feedback type="invalid">
                      Please provide a valid last name.
                    </FormControl.Feedback>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md="6">
                  <Form.Group>
                    <Form.Label className="contact-form-label">Email <span className="required-mark">*</span></Form.Label>
                    <Form.Control
                      name="email"
                      type="email"
                      value={email || ''}
                      onChange={handleChange}
                      required
                      placeholder="Type your email here..." />
                    <FormControl.Feedback type="invalid">
                      Please provide a valid email.
                    </FormControl.Feedback>
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label className="contact-form-label">Phone Number <span className="required-mark">*</span></Form.Label>
                    <Form.Control
                      name="phoneNumber"
                      type="phone"
                      value={phoneNumber || ''}
                      onChange={handleChange}
                      required
                      placeholder="Type your phone number here..." />
                    {/*  <InputMask mask="(999) 999-9999" maskChar=" " />*/}
                    <FormControl.Feedback type="invalid">
                      Please provide a valid phone number.
                    </FormControl.Feedback>
                  </Form.Group>
                </Col>
              </Row>
                <Form.Label className="contact-form-label">Message <span className="required-mark">*</span></Form.Label>
                <Form.Control
                  name="message"
                  as="textarea"
                  rows="4"
                  className="contact-form-message"
                  value={message || ''}
                  onChange={handleChange}
                  required
                  placeholder="Type your message here..." />
                <FormControl.Feedback type="invalid">
                  Please enter a content of your message.
                </FormControl.Feedback>
              <Row>
                <Col className="ml-auto mr-auto" md="4">
                  <Button 
                    className="btn-round send-message-button"
                    type="submit"
                  >
                    SEND MESSAGE
                  </Button>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default WebInquiryForm;